import { TYPE_TEAMS } from '@/constants';
import { getRandomItemFromArray } from '@/utilities';

export default class CheckBugSolver {
  constructor(reference) {
    this.reference = reference;
  }

  // eslint-disable-next-line class-methods-use-this
  chooseTeam() {
    const teamType = getRandomItemFromArray([
      TYPE_TEAMS.RD, TYPE_TEAMS.PM, TYPE_TEAMS.UX,
    ]);
    this.reference.task.checkBug();
    this.reference.task.updateAcceptTeamType(teamType);
    return teamType;
  }
}
